var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsFilterIcon = function SvgSettingsFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31,
    fill: "currentColor",
    viewBox: "0 0 72 66"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.292.688a7.833 7.833 0 1 0 0 15.666 7.833 7.833 0 0 0 0-15.666m0 13.708a5.875 5.875 0 1 1 0-11.75 5.875 5.875 0 0 1 0 11.75m0 35.25a7.833 7.833 0 1 0 0 15.666 7.833 7.833 0 0 0 0-15.666m0 13.708a5.875 5.875 0 1 1 0-11.75 5.875 5.875 0 0 1 0 11.75m27.416-38.187a7.833 7.833 0 1 0 0 15.666 7.833 7.833 0 0 0 0-15.666m0 13.708a5.875 5.875 0 1 1 0-11.75 5.875 5.875 0 0 1 0 11.75M.75 7.542h10.77V9.5H.75zM71.25 56.5H33.063v1.959H71.25zM33.063 7.542V9.5H71.25V7.542zM11.52 58.459H.75V56.5h10.77zm48.958-24.48H71.25v-1.958H60.48zM.75 32.022h38.188v1.959H.75z",
    clipRule: "evenodd"
  })));
};
export default SvgSettingsFilterIcon;